import _ from 'lodash';
import isPrimitive from './isPrimitive';
import Enveloped from './Interfaces';

function unwrap(object: readonly object[]): readonly object[];
function unwrap(object: Enveloped): readonly object[];
function unwrap(object: object): object;
function unwrap(object: object): object {
  if (_.isArray(object)) {
    return object.map((value) => {
      if (value && typeof value === 'object' && !isPrimitive(value)) {
        return unwrap(value);
      }
      return value;
    });
  }
  const data = _.get(object, 'data');
  if (Array.isArray(data)) {
    // we have found Enveloped data
    return unwrap(data);
  }
  return _.mapValues(object, (value) => {
    if (value && typeof value === 'object' && !isPrimitive(value)) {
      return unwrap(value);
    }
    return value;
  });
}

export default unwrap;
